var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    fill: "#007bff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M659.3,966.7H131.7C64.6,966.7,10,912.1,10,844.9V155.1C10,87.9,64.6,33.3,131.7,33.3h527.6c67.1,0,121.7,54.6,121.7,121.7v220.4c0,22.4-18.2,40.6-40.6,40.6c-22.4,0-40.6-18.2-40.6-40.6V155.1c0-22.4-18.2-40.6-40.6-40.6H131.7c-22.4,0-40.6,18.2-40.6,40.6v689.9c0,22.4,18.2,40.6,40.6,40.6h527.6c22.4,0,40.6-18.2,40.6-40.6v-78.2c0-22.4,18.2-40.6,40.6-40.6c22.4,0,40.6,18.2,40.6,40.6v78.2C781,912.1,726.4,966.7,659.3,966.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.9,313.3L617,600.3l-20.3,115.9l109.9-33.5L990,399.4L903.9,313.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.9,743.5c-3.4,0-6.8-0.8-9.9-2.6c-9.8-5.5-13.2-17.9-7.7-27.7c86.9-154,120.5-148.7,131.7-146.9c8.2,1.3,22.6,7,27.6,31.1c4.2,20.7,5.4,41.5,6.4,58.3c0.2,3.6,0.5,7.7,0.7,11.7l14.7-16c30.2-33.4,48.6-53.5,71.7-48c19.9,4.6,25.9,26.2,27.9,33.3c3.3,11.8,3.3,22.9,2.3,32.3c3-1.3,6.5-2.9,10.4-4.6c10.2-4.7,22.2-0.2,26.9,10.1c4.6,10.2,0.2,22.2-10.1,26.9c-32.3,14.7-49.8,21.9-63.6,10.5c-12.2-10-8.7-24.6-6.4-34.4c2.1-8.9,4.5-19.1,1.5-29.7c0-0.2-0.1-0.3-0.1-0.5c-8,6.8-20.1,20.2-30.3,31.5l-16.3,17.9c-8.7,9.4-26.6,28.8-46.7,21.5c-19.9-7.1-21.2-29.3-23-59.9c-0.9-14.4-1.8-30.6-4.5-46.4c-18.7,16.4-54.4,66.8-85.3,121.6C226.9,739.8,220,743.5,212.9,743.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3,276.8h446.4v40.6H172.3V276.8L172.3,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3,358h446.4v40.6H172.3V358L172.3,358z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3,439.1h365.2v40.6H172.3V439.1L172.3,439.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contract-icon.4948ac8e87e8d2b7b7c0885298ef17b0.svg";
export { ForwardRef as ReactComponent };